// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createSelector } from 'reselect';

export const manageAadUsersSelector = createSelector(
    (state): any => state,
    (res: { manageAadUsers: any }) => res.manageAadUsers
);

export const addAadUserStatusSelector = createSelector(
    manageAadUsersSelector,
    res => res.addAadUser || { status: undefined }
);

export const addBulkAadUsersStatusSelector = createSelector(
    manageAadUsersSelector,
    res => res.addBulkAadUsers || []
);